import React, { SVGProps } from 'react';
const chevronRightOutlined = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z" /></svg>;
export default chevronRightOutlined;